import{toString}from"@visx/scale";export default function getTickFormatter(scale){return"tickFormat"in scale?scale.tickFormat():toString}